import CONFIRM_DIALOGS from './confirm-dialog/es';
import ERROR_DIALOGS from "./error-dialog/es";
import RESULT_DIALOGS from "./result-dialog/es";

export default {
    BUTTONS: {
        SUBMIT: "Enviar",
        PREVIOUS: "Anterior",
        NEXT: "Siguiente",
        VIEW: "Ver",
        UPLOAD: "Subir",
        UPLOAD_FILE: "Subir archivo",
        VIEW_FILE: "Ver archivo",
        DELETE_FILE: "Eliminar archivo",
        CLOSE: "Cerrar",
        DELETE: "Eliminar",
        CANCEL: "Cancelar",
        YES: "Sí",
        NO: "No",
        OK: "Está bien",
        ADD: "Agregar",
        UPDATE_STATUS: "Estado de actualización",
        RETURN_DASHBOARD: "Volver al panel",
        REFRESH: "Actualizar",
        BULK_UPDATE_STATUS: "Actualizar estado de seleccionado",
        BULK_UPDATE_LOCATIONS: "Actualizar ubicaciones de seleccionados",
        BULK_UPDATE: "Actualización masiva",
        CHARGE_THROUGH_AUTHORIZE_NET: "Cobro a través de Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Carga a través de banda",
        INVOICE_THROUGH_STRIPE: "Factura a través de Stripe",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Cargar cliente y candidato de pago",
        BULK_DELETE: "Eliminar seleccionado",
        BULK_UNASSIGNED: "Desasignar seleccionado",
        EXPORT_EMPLOYERS: "Exportar lista de correo de clientes",
        EXPORT_CANDIDATES: "Exportar lista de distribución de candidatos",
        UPDATE_MANAGER: "Administrador de actualizaciones",
        VIEW_PROFILE: "Ver perfil",
        VIEW_OFFER: "Ver oferta",
        SAVE: "Guardar",
        EXPAND_ALL: "Expandir todo",
        COLLAPSE_ALL: "Contraer todo",
        SELECT_ALL: "Seleccionar todo",
        UNSELECT_ALL: "Deseleccionar todo",
        RESET_FILTERS: "Restablecer filtros",
        CLOCK_IN: "Reloj de entrada",
        ADD_A_BREAK: "Agregar un descanso",
        CLOCK_OUT: "Reloj de salida",
        CONFIRM_CLOCK_IN_OUT: "Confirmación del cliente",
        LEAVE_REVIEW: "Dejar una reseña",
        DECLINE: "Rechazar",
        DECLINE_WITHOUT_NOTIFICATION: "Rechazar sin notificación",
        UNDECLINE: "No declive",
        ACCEPT: "Aceptar",
        CHECK_PAYMENT: "Expresión de cheque de pago",
        ASSIGN: "Asignar",
        TENTATIVELY_ASSIGN: "Asignar tentativamente",
        SIGN: "Firmar",
        EDIT: "Editar",
        DUPLICATE: "Duplicado",
        ADD_A_BOOKING: "Añadir una Reserva",
        ADD_A_GROUP: "Agregar un grupo"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Nuevo Estado",
        NEW_LOCATIONS: "Nuevas ubicaciones",
        FILTER_BY_STATUS: "Filtrar por estado",
        FILTER_BY_STATUSES: "Filtrar por Estados",
        STATUSES_TO_HIDE: "Estados para Ocultar",
        FILTER_BY_LOCATIONS: "Filtrar por Ubicaciones",
        FILTER_BY_TYPES: "Filtrar por Tipos",
        FILTER_BY_MANAGER: "Filtrar por Gerente",
        FILTER_BY_CATEGORIES: "Filtrar por Categorías",
        FILTER_BY_START_DATE: "Filtrar por fecha de inicio",
        FILTER_BY_END_DATE: "Filtrar por fecha de finalización",
        FILTER_BY_WEEK_DAY: "Filtrar por día de la semana",
        FILTER_BY_CLIENTS: "Filtrar por Clientes",
        FILTER_BY_CLIENT_STATUSES: "Filtrar por Estados del Cliente",
        FILTER_BY_CLIENT_TYPES: "Filtrar por tipos de clientes",
        FILTER_BY_CANDIDATES: "Filtrar por candidato(s)",
        FILTER_BY_JOB_TYPES: "Filtrar por tipos de trabajo",
        FILTER_BY_JOB_STATUSES: "Filtrar por estado de trabajo",
        FILTER_BY_JOB_ID: "Filtrar por ID de trabajo",
        SELECT_SCRAPER_ACCOUNTS: "Sélectionnez les comptes Scraper",
        FILTER_BY_USER_TYPE: "Filtrar por tipo de usuario",
        KEYWORD_SEARCH_USER_PROFILE: "Busque la palabra clave/frase en cualquier parte del perfil de usuario, presione Intro para aplicar la búsqueda",
        SEARCH_BY_NAME_EMAIL_PHONE: "Buscar por nombre, correo electrónico o número de teléfono",
        FILTER_BY_RECENT_ACTIVE: "Filtrar por activos recientes",
        SELECT_LOCATIONS: "Seleccionar ubicaciones",
        SELECT_OPTION: "Seleccionar opción",
        SELECT_CLIENT: "Seleccionar Cliente",
        SELECT_CANDIDATE: "Seleccionar candidato",
        SELECT_CANDIDATES: "Seleccionar candidatos",
        SELECT_CANDIDATE_SEARCHABLE: "Seleccionar Candidato (Escribir para buscar)",
        SELECT_ADMINS: "Seleccionar administradores",
        SELECT_ADMIN_RECEIVE_EMAIL: "Seleccionar administradores que reciben correos electrónicos",
        SELECT_STATUS: "Seleccionar Estado",
        SELECT_LANGUAGES: "Seleccionar idiomas",
        SELECT_TYPES: "Seleccionar tipos",
        SELECT_TYPE: "Seleccionar tipo",
        SELECT_USER_TYPE: "Seleccionar tipo de usuario",
        SELECT_USER_TYPES: "Seleccionar tipos de usuarios",
        SELECT_CATEGORY: "Seleccionar categoría",
        SELECT_CATEGORY_ADMIN_ONLY: "Seleccionar categoría (solo administrador)",
        SELECT_TRIGGER: "Seleccionar disparador",
        SELECT_ONE: "Seleccionar uno",
        SELECT_PROFILE_BUILDER: "Seleccionar Creador de perfiles",
        SELECT_TIME_OFF_CATEOGRY: "Seleccionar categoría de tiempo libre",
        SELECT_DESTINATION: "Seleccionar destino",
        SELECT_ACCESS_LEVEL: "Seleccionar nivel de acceso",
        SELECT_VISIBILITY_SCOPE: "Seleccionar alcance de visibilidad",
        SELECT_AREAS: "Seleccionar Áreas",
        NUMBER: "Número",
        DESCRIPTION_CHARGE: "Descripción del cargo",
    },
    LABELS: {
        SELECT_TEMPLATE: "Seleccionar plantilla",
        FILTER_BY_LOCATIONS: "Filtrar por Ubicaciones",
        FILTER_BY_TYPES: "Filtrar por Tipos",
        FILTER_BY_MANAGER: "Filtrar por Gerente",
        FILTER_BY_CATEGORIES: "Filtrar por Categorías",
        FILTER_BY_STATUS: "Filtrar por estado",
        ADDRESS: "Dirección",
        CITY: "Ciudad",
        STATE: "Estado",
        COUNTRY: "País",
        ZIP_CODE: "Código postal",
        LOCATIONS: "Ubicaciones",
        DESCRIPTION: "Descripción",
        PER_HOUR: "por hora"
    },
    HEADERS: {
        EMAIL_LOG: "Registro de correo electrónico",
        SMS_LOG: "Registro de SMS"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Cómo ocultar estados por defecto",
        HOW_TO_CHANGE_STATUS: "Cómo agregar/cambiar estados"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Separar varios correos electrónicos con ; (p. ej.: nanny1@hotmail.com; nanny2@hotmail.com)",
        SMS_NOTE: `Tenga en cuenta que hay un costo de $0.0115 (1.15¢) por SMS.`,
        CLIENT_NOT_ENTERED_STRIPE: "El cliente no ha ingresado la información de Stripe.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "El cliente no ha ingresado la información de Authorize.Net.",
        CANDIDATE_NOT_ENTERED_STRIPE: "El candidato no ha ingresado la información de Stripe",
        INTERVIEW_PANEL: `Nota: estas notas son solo para uso del administrador interno y no son
        compartido con candidatos o clientes.`,
        CANDIDATE_SHAREABLE_LINK: `Este es un enlace para compartir del perfil del candidato. Si tu quieres
        para ver lo que verá un cliente, <strong>asegúrese de cerrar la sesión</strong> y luego
        ver el enlace (o abrirlo en un navegador diferente). Este <strong>no</strong> es un enlace para que su candidato inicie sesión. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Más información</a>`,
        CLIENT_SHAREABLE_LINK: `Este es un enlace para compartir del perfil del cliente. Si quieres
        ver lo que verá un candidato, <strong>asegúrese de cerrar la sesión</strong> y luego
        ver el enlace (o abrirlo en un navegador diferente). Este <strong>no</strong> es un enlace para que sus clientes inicien sesión. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Más información</a>`
    },
    TABLE_HEADERS: {
        ACTIONS: "Acciones",
        NOTES: "Notas",
        VALUE: "Valor",
        EFFECTIVE_FROM: "Efectivo desde",
        EFFECTIVE_UNTIL: "Efectivo hasta",
        TYPE: "Tipo"
    },
    OPCIONES: {
        "YES": "Sí",
        "NO": "No"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Este campo es obligatorio"
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "¡Gracias!",
        STEP_OF: "Paso {0} de {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Por favor, ayúdenos a completar el formulario a continuación",
        REFERENCE_FOR: "Referencia para {0} {1}",
        REFERENCE_INPUT_BY: "Información de referencia ingresada por {0} {1}",
        FORM_SUBMITTED: "¡El formulario de verificación de referencia ha sido enviado!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Soltar un archivo aquí o hacer clic para cargar",
        MAXIMUM_UPLOAD_SIZE: "Tamaño máximo de carga {0} MB",
        FILE_EXCEED_MAXIMUM: "El tamaño del archivo supera los {0} MB.",
        FILE: "Archivo"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Reservas",
            HIDE_PAST_BOOKINGS: "Ocultar reservas anteriores",
            BOOKING_CREDIT_LEFT: "Quedan {0} créditos de reserva",
            MIN_BOOKINGS_REQUIRE: "¡Necesitas al menos {0} reservas!",
            SELECTED_CANDIDATE: "Candidato seleccionado",
            TOTAL_BOOKING_FEE: "Tarifa de reserva total",
            BOOKING_GROUPS: "Reservar Grupos"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Haga clic en la reserva (en el calendario) para obtener más información sobre su proveedor de servicios asignado y dejar una reseña",
            CLICK_ON_DATE: "Haga clic en una fecha para agregar una reserva.",
            CLICK_ON_OTHER_DATE: "Haga clic en otra fecha en el calendario para agregar una reserva",
            BOOKING_GROUP: "Todas las reservas en el mismo grupo deben asignarse a un asignado"
        },
        PRICES: {
            BOOKING_RATE: "Tarifa de reserva",
            BOOKING_FEE: "Tarifa de reserva",
            PER_BOOKING_FEE: "Por tarifa de reserva",
            CLIENT_RATE: "Tarifa Cliente",
            CANDIDATE_RATE: "Tarifa de candidato",
            AGENCY_FEE: "Tarifa de agencia",
            TRAVEL_FEE: "Tarifa de viaje",
            RUSH_FEE: "Tarifa urgente",
            CANDIDATE_RUSH_FEE: "Tarifa urgente de candidato",
            PER_BOOKING_AGENCY_FEE: "Tarifa por agencia de reservas",
            PER_BOOKING_CANDIDATE_FEE: "Tarifa de candidato por reserva",
            ADMIN_FEE: "Tarifa administrativa",
            ADDITIONAL_FEES: "Tarifas adicionales"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            START_TIME: "Hora de inicio",
            END_TIME: "Hora de finalización",
            END_DATE: "Fecha de finalización",
            SELECT_CLIENT: "Seleccionar Cliente",
            ASSIGNED_CANDIDATE: "¿Desea asignar este trabajo?",
            TENTATIVELY_ASSIGN_CANDIDATE: "¿Desea asignar provisionalmente este trabajo?",
            REPEAT: "¿Quieres este servicio más de una vez (repetitivo/recurrente)?",
            REPEAT_UNTIL: "Repetir hasta",
            REPEAT_EVERY: "Repetir cada",
            REPEAT_ON: "Repetir en",
            BOOKING_ADDRESS: "Dirección de reserva",
            ADDRESS_LINE2: "Línea de dirección 2",
            CITY: "Ciudad",
            STATE: "Estado/Provincia",
            ZIP_CODE: "Código postal",
            NUMBER_CHILDREN: "¿Cuántos niños se cuidarán?",
            SELECT_JOB_CATEGORY: "Seleccionar categoría de trabajo",
            SELECT_DATE: "Fecha de reserva",
            SELECT_SERVICE: "Seleccionar servicio"
        },
        OPCIONES: {
            REPEAT_TYPE: ["Días", "Semanas"],
            REPEAT_ON: [
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
                "Domingo"
            ]
        }
    },
    MENU_BAR: {
        TOP: {
            MESSAGES: "Mensajes",
            SMS: "SMS",
            JOBS: "Trabajos",
            LOGOUT: "Cerrar sesión",
            DASHBOARD: "Mi panel de control"
        },
        ADMIN: {
            USERS: {
                ROOT: "Usuarios",
                CLIENTS: "Clientes",
                CANDIDATES: "Candidatos",
                ADMINISTRATORS: "Administradores"
            },
            JOBS_EVENTS: {
                ROOT: "Trabajos y Calendario",
                SHIFT_JOB_CALENDAR: "Calendario de trabajo por turnos",
                PLACEMENT_JOBS: "Trabajos de colocación",
                PERSONAL_TO_DO: "Personal para hacer"

            },
            TEMPLATES: {
                ROOT: "Plantillas",
                EMAIL: "Plantillas de correo electrónico",
                SMS: "Plantillas de SMS",
                DOCUMENT: "Plantillas de documentos",
                NOTE: "Plantillas de notas",
                PROFILE: "Plantillas de perfil",
            },
            AÑADIR_CLAVE_RANDOM_AJUSTES: {
                ROOT: "Configuración",
                AGENCY: "Configuración de la agencia",
                ADMIN: "Configuración de administrador"
            },
            BUILDERS: {
                ROOT: "Constructores",
                PROFILE: "Generador de perfiles",
                EVALUATION: "Generador de evaluación"
            },
            LOGS: {
                ROOT: "Registros",
                COMMUNICATION_LOG: "Registro de comunicación",
                STATUS_CHANGES: "Cambios de estado",
                ACTIVITY_LOG: "Registro de actividad",
                PAYMENT_LOG: "Registro de pagos",
            },
            OTHERS: {
                ROOT: "Otros",
                RESOURCE_MANAGER: "Administrador de recursos",
                REFERENCES: "Referencias",
                DOCUMENTS: "Documentos",
                EMAIL_BLASTER: "Blaster de correo electrónico",
                NOTIFICATION_CENTER: "Centro de notificaciones",
                SNAPSHOT: "Instantánea",
                COMMUNITY: "Comunidad"
            }

        },
        CANDIDATOS: {
            MY_PROFILE: "Mi perfil",
            AVAILABLE_JOBS: "Trabajos disponibles",
            MY_SCHEDULE: "Mi horario",
            MY_JOBS: "Mis trabajos",
            MY_FAMILIES: "Mis familias"
        },
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Conceptos básicos del generador de perfiles",
            REQUIRE_FIELD: "Cómo marcar preguntas/campos como obligatorios o no",
            NOTIFICATION_DESTINATION: "Editar a quién se notifican los nuevos solicitantes",
            EDIT_APPLICATION: `Cómo editar formularios de solicitud más fácilmente`,
            ADD_SECTION_QUESTION: "Cómo agregar una pregunta a una sección",
            ADD_CONFIRMATION_BOX: "Cómo agregar campos de confirmación en los formularios de solicitud"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Primeros pasos con las evaluaciones"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Primeros pasos con las plantillas de correo electrónico",
            DEFAULT_EMAIL_FOOTER: "Configuración de su pie de página de correo electrónico predeterminado"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Primeros pasos con las plantillas de documentos",
            NOTIFICATION_WHEN_SIGNED: "Agregar notificación cuando se firma el documento",
            ADD_DOCUMENT: "Agregar manualmente un documento a un usuario"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Mapeo de su proceso a través de estados, listas de verificación y tipos",
            AGENCY_BRANDING_SETUP: "Configuración de la marca de la agencia (logotipo, colores, fuentes)",
            PROFILE_COMPLETE_SETUP: `Cómo agregar un botón "Mi perfil está completo" Los candidatos pueden hacer clic para notificarle que han completado su perfil`,
            CONFIGURE_MULTIPLE_LOCATIONS: "Configurar su agencia para atender varias ubicaciones distintas"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Cómo funcionan los envíos masivos de correo electrónico"
        },
        CLIENTS:{
            SHARE_CANDIDATE_PROFILE: "Cómo compartir el perfil de una candidata con una cliente."
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Bienvenido a {0} Control de Misión",
        PRO_CONSEJO: {
            HEADER: "Novedades de esta semana:",
            TEXT: "¡Enlaces directos para dejar reseñas!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Ordenar Clientes Por",
            ORDER_CANDIDATES_BY: "Ordenar candidatos por"
        },
        BUTTONS: {
            ADD_CLIENT: "Agregar Cliente",
            ADD_CANDIDATE: "Agregar candidato",
        },
    },
    ADD_USER_DIALOG: {
        HEADER: "Agregar Nuevo Usuario",
        DESCRIPTION: `Este es un mecanismo para agregar manualmente un usuario a su base de datos. Un usuario
        agregado de esta manera se pondrá en el estado "Aplicación previa"
         (lo que significa que aún no han completado un formulario de solicitud). un usuario en
        este estado todavía se puede enviar para completar el formulario de solicitud. Si usted
        le gustaría enviar automáticamente un correo electrónico a los usuarios agregados de esta manera, usted
        puede agregar una plantilla de correo electrónico que sea una "Notificación de cambio de estado"
        triggering en un cambio a "Aplicación previa".`,
        LABELS: {
            EMAIL: "Correo electrónico",
            PHONE: "Número de teléfono",
            FIRST_NAME: "Nombre",
            LAST_NAME: "Apellido",
            PROFILE_BUILDER: "Generador de perfiles",
            USER_TYPES: "Tipos de Usuario",
            LOCATIONS: "Ubicaciones",
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Su cuenta se ha conectado correctamente con Stripe",
        FAILED_TO_CONECT: "Hubo un problema al conectar su cuenta con Stripe, intente nuevamente o comuníquese con Enginehire",
        MISSING_INFO: "Su cuenta ha sido conectada pero falta información en la aplicación de Stripe, haga clic en el botón de conexión a Stripe para continuar donde lo dejó",
    },
    DATA_TABLE: {
        SHOW: "Mostrar",
        ITEMS_PER_PAGE: "elementos por página",
        SHOWING_RANGE: "Mostrando {0} a {1} de {2} entradas"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Administrador",
            PROFILE: "Perfil",
            INTAKE_NOTES: "Notas de admisión",
            COMMUNICATION_LOG: "Registro de comunicación",
            RECORDS: "Registros",
            INTAKE_NOTES_MOBILE: "Notas",
            COMMUNICATION_LOG_MOBILE: "Comu"
        },
        INTERVIEW_TABS: {
            PROFILE: "Perfil",
            NOTES: "Notas"
        },
        BUTTONS: {
            DELETE_CLIENT: "Eliminar Cliente"
        },
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Administrador",
            PROFILE: "Perfil",
            INTERVIEW: "Entrevista",
            COMMUNICATION_LOG: "Registro de comunicación",
            RECORDS: "Registros",
            COMMUNICATION_LOG_MOBILE: "Com"
        },
        INTERVIEW_TABS: {
            PROFILE: "Perfil",
            INTERVIEW: "Entrevista"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Eliminar candidato"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Tipos",
            BUTTON: "Guardar tipos"
        },
        CHECKLIST: {
            TITLE: "Lista de verificación",
            BUTTON: "Guardar lista de control"
        },
        TAGS: {
            TITLE: "Administrador de etiquetas",
            BUTTON: "Guardar etiquetas"
        },
        LOCATIONS: {
            TITLE: "Ubicaciones",
            BUTTON: "Guardar ubicaciones"
        },
        LANGUAGE: {
            TITLE: "Idioma",
            BUTTON: "Guardar idioma"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Tipo de perfil",
            BUTTON: "Actualizar generador de perfiles"
        },
        NOTAS: {
            TITLE: "Notas",
            DESCRIPTION: "Las notas tomadas aquí son solo para uso interno del administrador, no visibles para los usuarios",
            BUTTON: "Agregar nota"
        },
        EMAIL: {
            TITLE: "Enviar correo electrónico",
            BUTTON_SEND: "Enviar",
            BUTTON_LOAD: "Cargar",
            SELECT_TEMPLATE: "Seleccionar plantilla",
            FROM_EMAIL: "De correo electrónico"
        },
        SMS: {
            TITLE: "Enviar SMS",
            BUTTON: "Enviar"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "Puede restablecer manualmente la contraseña del usuario aquí",
            BUTTON: "Actualizar contraseña"
        },
        EVENT: {
            TITLE: "Programar Evento (Entrevista, Reunión, etc.)",
            DESCRIPTION: "Estos eventos aparecerán en el tablero del usuario.",
            EVENT_TITLE: "Título del evento",
            EVENT_DATE: "Fecha del evento",
            EVENT_TIME: "Hora del evento",
            INTERVIEW_LINK: "Enlace de entrevista",
            INTERVIEW_LINK_PLACE_HOLDER: "Enlace de zoom u otro enlace de llamada",
            NOTES: "Notas",
            STATUS_UPDATE_TO: "Estado para actualizar usuario a",
            SEND_EMAIL_NOTIFICATION: "Enviar notificación por correo electrónico del evento programado",
            ADD_TO_CALENDAR: "Agregar al calendario personal de tareas pendientes",
            BUTTON: "Programar evento"
        },
        CREDIT: {
            TITLE: "Créditos",
            BUTTON_ADD: "Agregar crédito",
            BUTTON_EDIT: "Editar",
            EDIT_CREDIT_TITLE: "Editar crédito",
            PLACE_HOLDERS: {
                VALUE: "Valor",
                NOTES: "Notas"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Puede facturar manualmente a los clientes a través de Stripe aquí",
            SEND_INVOICE: "Puede enviar facturas Stripe manualmente aquí",
            BUTTON_CHARGE: "Cargar a través de Stripe",
            BUTTON_RESET: "Restablecer información de banda",
            BUTTON_INVOICE: "Factura a través de Stripe",
            PAYMENT_LOGS: "Registros de pago"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "Puede facturar manualmente a los clientes a través de Authorize.Net aquí",
            SEND_INVOICE: "Puede enviar facturas de Authorize.Net manualmente aquí",
            BUTTON_CHARGE: "Cobro a través de Authorize.Net",
            BUTTON_RESET: "Restablecer información de Authorize.Net",
            BUTTON_INVOICE: "Facturar a través de Authorize.Net",
            PAYMENT_LOGS: "Registros de pago"
        },
        REVIEW: {
            TITLE: "Reseñas",
            RATING: "Clasificación",
            AVERAGE_RATING: "Calificación promedio",
            NO_DATA: "Todavía no hay reseñas"
        },
        ADD_DOCUMENTO: {
            TITLE: "Agregar Documento",
            DESCRIPTION: `Puede agregar cualquier plantilla de documento al usuario desde aquí, solo seleccione una
            of sus documentos del menú desplegable:`,
            BUTTON: "Agregar documento",
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Candidatos asignados",
                NO_CANDIDATE: "No se han vinculado candidatos a este cliente"
            },
            CLIENTE: {
                TITLE: "Clientes asignados",
                NO_CLIENT: "No se han vinculado clientes a este candidato"
            },
            ADD_CANDIDATE: "Agregar candidato"
        },
        LAST_CONTACTED_DATE: "Última fecha de contacto",
        CANDIDATE_BADGES: {
            TITLE: "Insignias de candidatos",
            BUTTON: "Guardar insignias"
        }
    },
    COMMUNICATION: {
        DATE: "Fecha",
        FROM: "Desde",
        TO: "Para",
        SUBJECT: "Asunto",
        MESSAGE: "Mensaje",
        RE_SEND: "Reenviar"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Buscar por título de trabajo, ID de trabajo, horario, ciudad, estado o descripción",
        JOB_HIDEN_DESCRIPTION: `Los trabajos en el estado "Borrador", "Cerrado" o "Llenado" no aparecen en el trabajo
        board por defecto. Para actualizar el estado de un trabajo, haga clic en "Editar trabajo".`,
        CLIENT_POSTING_JOB_DESCRIPTION: "Esto es para publicar posiciones a largo plazo para este cliente.",
    },
    CONFIRM_DIALOGS: CONFIRM_DIALOGS,
    ERROR_DIALOGS: ERROR_DIALOGS,
    RESULT_DIALOGS: RESULT_DIALOGS
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/es.js